import { InvalidTargetError } from '../utils/errors';

export class ClickRedirect {
  constructor(el, config) {
    this.el = el;
    this.updateConfig(config);
    this.onClick = this.onClick.bind(this);
    this.isActive = false;
  }

  updateConfig({ selector, isDisabled, parent }) {
    this.parent = parent || undefined;
    this.selector = selector || undefined;
    this.isDisabled = isDisabled || false;
  }

  activate() {
    if (this.isActive) return;
    this.isActive = true;
    this.el.addEventListener('click', this.onClick);
    this.el.classList.add('has-click-redirect');
  }

  deactivate() {
    if (!this.isActive) return;
    this.isActive = false;
    this.el.removeEventListener('click', this.onClick);
    this.el.classList.remove('has-click-redirect');
  }

  onClick(event) {
    if (this.isDisabled) return;
    ClickRedirect.Redirect(this.el, this.selector, this.parent)
      .then(() => event.preventDefault())
      .catch(error => {
        if (error.name === 'InvalidTargetError') return;
        throw error;
      });
  }

  static Redirect(el, selector, parent) {
    return new Promise((resolve, reject) => {
      const baseElement = parent ? el.closest(parent) : document;
      const target = baseElement.querySelector(selector);

      if (!target) return reject(new InvalidTargetError());

      target.click();
      resolve();
    });
  }
}
